import React from 'react'
import AllroadBarGraph from './AllroadBarGraph'
import styled from 'styled-components'

import Navbar from '../../defaultComponents/Navbar'
import Footer from '../../defaultComponents/Footer'
import AllroadDashboardPieGraph from './AllroadDashboardPieGraph'
import AllroadBarGraphPercentages from './AllroadBarGraphPercentages'
import AllroadMonthlyGraph from './AllroadMonthlyGraph'
import AllroadBarGraphLiveWeek from './AllroadBarGraphLiveWeek'

const PageWrapper = styled.div`
  height: 100vh;
`

const DashboardBoxWrapper = styled.div`
  display: flex;
  width: 100%;
  
  justify-content: center;
  align-items: center;
`

const DashboardBox = styled.div`
  display: grid;
  grid-template-columns: 45vw 45vw;
  grid-template-rows: 20vw 20vw;
  gap: 50px;
`

const DashboardSection = styled.div`

  border: 1px solid #ddd;
  border-radius: 15px;
  
  padding: 2vw;
  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;
`

const GraphContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 45vw;

  gap: 1vw;
`

const GraphWrapper = styled.div`
  
  border: 1px solid #ddd;
  border-radius: 15px;

  width: 20vw;
  height: 30vh;
`

const GraphTitle = styled.div`
  font-weight: bold;

  text-align: center;
`

const SectionTitle = styled.div`
  font-weight: bold;
`

const ClientsContainer = styled.div`

  flex: 1;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;


  gap: 10px;

  margin-top: 1vh;
`

const ClientBox = styled.div`
  border: 2px solid tomato;
  border-radius: 5px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  text-align: center;



  padding-left: 1vw;
  padding-right: 1vw;
`

const ClientName = styled.div`
  font-weight: bold;
  color: tomato;
`

export default function AllroadDashboardPageSummary() {
  const [assignarMonthlyData, setAssignarMonthlyData] = React.useState({});
  const [weeklyData, setWeeklyData] = React.useState({});

  const [projectedHoursList, setProjectedHoursList] = React.useState({})
  const [clientHours, setClientHours] = React.useState({})


  const sortDataByMonth = (data) => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const sortedData = {};
    months.forEach(month => {
      if (data[month]) {
        sortedData[month] = data[month];
      }
    });

    return sortedData;
  }

  const getMonthlyData = async () => {
    try {
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/masterDashboard/monthlyData/Allroad`);

      const data = await response.json();

      const sortedData = await sortDataByMonth(data);

      setAssignarMonthlyData(sortedData);

    } catch (error) {
      console.error("Error getting monthly data", error)
    }
  }

  const getWeeklyCompleteHours = async () => {
    const myDates = await getWeekDates();
    const weekStart = myDates[0]
    let weekEnd = myDates[myDates.length - 1]

    try {
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/masterDashboard/weeklyData/Allroad/${weekStart}/${weekEnd}/breakdown`)

      if (!response.ok) {
        console.log("Error fetching data from backend", response.statusText);
        return null;
      }

      const data = await response.json();

      // alert(JSON.stringify(data));
      setWeeklyData(data)

    } catch (error) {
      console.error("Error fetching the data", error)
    }
  }

  // --- Code for getting the projected hours for allroad
  const getWeekDates = (dateStr) => {
    const formatDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    // If a date string is provided, use it; otherwise, use the current date
    const currentDate = dateStr ? new Date(dateStr) : new Date();

    // Calculate the previous Monday
    const monday = new Date(currentDate);
    monday.setDate(monday.getDate() - (monday.getDay() === 0 ? 6 : monday.getDay() - 1));

    // Calculate the next Sunday
    const sunday = new Date(monday);
    sunday.setDate(sunday.getDate() + 6);

    // Create the list of dates
    const weekDates = [];
    for (let day = new Date(monday); day <= sunday; day.setDate(day.getDate() + 1)) {
      weekDates.push(formatDate(new Date(day)));
    }

    return weekDates;
  }

  const getPendingAllocations = async (targetDate) => {
    try {
      const res = await fetch(`/api/Assignar/allocations/hours/${targetDate}`)

      const data = await res.json()

      if (data.error) {
        throw new Error("Error getting Timesheets")
      }
      return data.hours
    } catch (error) {
      console.error(error)
    }
  }

  const getPendingAllocationsForWeek = async () => {
    const myDates = await getWeekDates();

    let myList = {}
    let total = 0
    for (var i = 0; i < myDates.length; i++) {
      const data = await getPendingAllocations(myDates[i])
      total += data
      myList[`${myDates[i]}`] = { totalHours: parseInt(data) }
    }

    setProjectedHoursList(myList)
    // alert(JSON.stringify(myList));
  };

  const getClientHours = async () => {

    const datesList = await getWeekDates();
    try {
      const res = await fetch(`/api/Assignar/clients/hours/byDateList`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/JSON',
        },
        body: JSON.stringify({ datesList: datesList }),
        credentials: "include"
      })

      const data = await res.json()

      if (data.error) {
        throw new Error("Error getting Timesheets")
      }

      // console.log(JSON.stringify(data))

      const dataArray = Object.values(data);

      // Sort the array based on the totalHours property
      dataArray.sort((a, b) => b.totalHours - a.totalHours);

      // If you need to convert it back to an object (Optional)
      const sortedData = {};
      dataArray.forEach((item, index) => {
        sortedData[index] = item;
      });

      setClientHours(sortedData)

    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    getMonthlyData();
    getWeeklyCompleteHours();
    getPendingAllocationsForWeek();
    getClientHours();
  }, [])

  return (
    <>
      <Navbar pageType="Dashboard" />
      <PageWrapper>
        <DashboardBoxWrapper>
          <DashboardBox>
            <DashboardSection>
              <GraphContainer>
                <div>
                  <GraphTitle>WEEKLY PROGRESS</GraphTitle>
                  <GraphWrapper>
                    <AllroadDashboardPieGraph pending={projectedHoursList} complete={weeklyData} />
                  </GraphWrapper>
                </div>

                {/* <div>
                  <div>Vehicle Utilisation</div>
                  <GraphWrapper>
                    <AllroadDashboardPieGraph />
                  </GraphWrapper>
                </div> */}
              </GraphContainer>
            </DashboardSection>
            <DashboardSection>
              <SectionTitle>
                TOP CLIENT HOURS
              </SectionTitle>

              <ClientsContainer>
                {
                  Object.keys(clientHours).slice(0, 8).map(clientKey => (
                    <ClientBox key={clientKey}>
                      <ClientName>{clientHours[clientKey].name}</ClientName>
                      <div>{clientHours[clientKey].totalHours}</div>
                    </ClientBox>
                  ))
                }
              </ClientsContainer>
            </DashboardSection>
            <DashboardSection className="GRAPH">
              <SectionTitle>
                LIVE WEEK HOURS
              </SectionTitle>
              <AllroadBarGraphLiveWeek weeklyData={weeklyData} projectedData={projectedHoursList} />

            </DashboardSection>
            <DashboardSection className="GRAPH">
              <SectionTitle>
                MONTHLY HOURS
              </SectionTitle>
              <AllroadMonthlyGraph monthlyData={assignarMonthlyData} />
            </DashboardSection>
          </DashboardBox>
        </DashboardBoxWrapper>
        <Footer />
      </PageWrapper>
    </>
  )
}